/** @class ManageItemPermissionsContainer
 *
 * @desc
 * Container to display information for a client about firm/advisor item permissions and option to manage them.
 *
 */

import {Component} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {updateResource} from 'redux-json-api'

import ManageItemPermissionsModal from './ManageItemPermissionsModal'
import {BoxGutterMedium} from '../../../blocks/Boxes'
import ItemPermissionsExplanation from './ItemPermissionsExplanation'
import ExistingItemPermissionInformation from './ExistingItemPermissionInformation'
import {findRawResourceByAttributeId} from '../../../../../../lib/plan_data/userData'
import {selectAllItemIds} from '../../../../../../lib/plan_data/itemSelectors'

export class ManageItemPermissionsContainer extends Component {
  componentDidMount() {
    this.props.readEndpoint(`firms/${this.props.firmOwnership.get('ownable-id')}?include=firm-config`)
  }

  isFirmPermissionsEditable() { return this.props.firm.get('firm-type') === 'firm' }

  render() {
    if (this.isFirmPermissionsEditable() && this.props.firmConfig.get('write-access')) {
      const advisorFullName = this.props.advisorContactCard.get('name')
      return (
        <BoxGutterMedium className='manage-item-permissions-container'>
          <h2>Permission to edit</h2>
          <ExistingItemPermissionInformation
            name={advisorFullName}
            ownership={this.props.firmOwnership}
          />
          <ManageItemPermissionsModal
            allItemIds={this.props.allItemIds}
            name={advisorFullName}
            ownership={this.props.firmOwnership}
            updateResource={this.props.updateResource}
          />
          <ItemPermissionsExplanation advisorFullName={advisorFullName} />
        </BoxGutterMedium>
      )
    } else {
      return null
    }
  }
}

ManageItemPermissionsContainer.propTypes = {
  advisorContactCard: PropTypes.instanceOf(Map),
  allItemIds: PropTypes.array,
  firm: PropTypes.instanceOf(Map),
  firmConfig: PropTypes.instanceOf(Map),
  firmOwnership: PropTypes.instanceOf(Map),
  readEndpoint: PropTypes.func,
  updateResource: PropTypes.func,
  userConfig: PropTypes.instanceOf(Map)
}

const mapStateToProps = (state, {firmOwnership, userConfig}) => ({
  allItemIds: selectAllItemIds(state),
  firmConfig: findRawResourceByAttributeId({
    rawResource: state.api['firm-configs'],
    attribute: 'firm-id',
    id: firmOwnership.get('ownable-id')
  }),
  firm: findRawResourceByAttributeId({
    rawResource: state.api.firms,
    attribute: 'id',
    id: firmOwnership.get('ownable-id')
  }),
  firmOwnership,
  userConfig
})

export default connect(mapStateToProps, {updateResource})(ManageItemPermissionsContainer)
